import { DOCTOR_HOW_IT_WORKS_PAGES } from '@medicusunion/front-utils';
import { Col, Row } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { setTour } from 'store/tour/slice';

import { HowItWorksLink } from 'components/shared';
import { PageWrapper } from 'components/ui';
import { PatientInfo, PatientList } from './components';

const Patients: FC = () => {
  const [renderInfo, setRenderInfo] = useState(false);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setTour({ key: 'patients', value: false }));
  }, [dispatch]);

  return (
    <PageWrapper
      title={t('patient.page_title')}
      color="white"
      hidePaddings
      extra={[
        <HowItWorksLink
          key="how-it-works"
          type={DOCTOR_HOW_IT_WORKS_PAGES.PATIENTS.key}
          title={t('common.how_it_works')}
        />
      ]}
    >
      <Row>
        <Col span={6}>
          <PatientList onReady={() => setRenderInfo(true)} />
        </Col>
        <Col span={18}>{renderInfo && <PatientInfo />}</Col>
      </Row>
    </PageWrapper>
  );
};

export default Patients;
